import { memo } from 'react'
import { BulkStatus, DgtPdOrderOperationLog } from '../models'
import { EditorProps } from 'react-data-grid'
import Modal from './Modal'
import { formatDateFromUnix, getMinuteTimeV2 } from '../utilities/Format'
import Badge from './Badge'

const BulkOperationLogEditor = memo(({ props, isApprove } : {
  props: EditorProps<DgtPdOrderOperationLog>, isApprove: boolean
}) => {
  const { onClose, onRowChange, row } = props

  return isApprove ? <Modal show={true} onHide={onClose}
    okTheme='success'
    okText='อนุมัติ'
    okAction={() => {
      const updatedRow = { ...row,
        approveBulkStatusDateTime: Math.floor(Date.now() / 1000)
      }
      onRowChange(updatedRow, true)
    }}
    cancelText='ปิด'
    title={`PD# - ${row.productionOrderId}`}
    >
    <>
    <div className='grid grid-cols-2 mb-3'>
      <h6>Material Code</h6>
      <h6 className='font-bold '>{row.materialCode}</h6>
      <h6>Material Description</h6>
      <h6 className='font-bold '>{row.materialDescription}</h6>
      <h6>Batch Lot</h6>
      <h6 className='font-bold '>{row.batchNo || ''}</h6>
      <h6>เริ่มตรวจเมื่อ</h6>
      <h6 className='font-bold '>{formatDateFromUnix(row.startedTime)}</h6>
      <h6>ตรวจเสร็จเมื่อ</h6>
      <h6 className='font-bold '>{formatDateFromUnix(row.finishedTime)}</h6>
      <h6>ตรวจเสร็จโดย</h6>
      <h6 className='font-bold '>{row.bulkStatusBy}</h6>
      <h6>TotalTime</h6>
      <h6 className='font-bold '>{row.totalTime ? `${getMinuteTimeV2(row.startedTime, row.finishedTime)} นาที` : '-'}</h6>
      <h6>Bulk Status</h6>
      <h6 className='font-bold '>
        { row.bulkStatus === BulkStatus.PASS && <Badge variant={` bg-green-600 text-xs text-white`}>{row.bulkStatus}</Badge> }
        { row.bulkStatus === BulkStatus.HOLD && <Badge variant={` bg-amber-400 text-xs text-white`}>{row.bulkStatus}</Badge> }
        { row.bulkStatus === BulkStatus.REJECT && <Badge variant={` bg-rose-600 text-xs text-white`}>{row.bulkStatus}</Badge> }
      </h6>

      <h6>Comment</h6>
      <h6 className='font-bold '>{row.bulkStatusComment}</h6>

    </div>
    <h6>คุณต้องการยืนยันรายการนี้หรือไม่ ?</h6>
    </>
  </Modal> : <Modal show={true} onHide={onClose}
    okTheme='danger'
    okText='ปฏิเสธ'
    okAction={() => {
      let updatedRow = { ...row }
      delete updatedRow.approveBulkStatusDateTime
      onRowChange(updatedRow, true)
    }}
    cancelText='ปิด'
    title={`กำลังปฏิเสธนับ ${row.materialCode} - ${row.materialDescription}`}
    >
    <h6>ยืนยันปฏิเสธใช่หรือไม่ ?</h6>
  </Modal>
})

export default memo(BulkOperationLogEditor)